import script from "./map.vue?vue&type=script&setup=true&lang=js"
export * from "./map.vue?vue&type=script&setup=true&lang=js"

import "./map.vue?vue&type=style&index=0&id=4f8f8a9f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\项目\\乐伴伴10.9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f8f8a9f"]])

export default __exports__